import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;

let http = baseService(store, tbRoute);

const apiDef = {
  imprimirHabitese(data) {
    return http.post(`/ObraProjetoHabiteseExterno/ImprimirHabitese`, data);
  },
  getDadosHabitese(data) {
    return http.post(`/ObraProjetoHabiteseExterno/GetDadosHabitese`, data);
  },
  validaHabitese(data) {
    return http.post(`/ObraProjetoHabiteseExterno/ValidaHabitese`, data);
  },
};

export default apiDef;
